import { redesignTheme } from '../theme';

const { spacing, breakpoints } = redesignTheme;

export const testListPageStyles = {
  page: {
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      paddingLeft: spacing.lg,
      paddingRight: spacing.lg,
    },
  },
  headerSearch: {
    width: 352,
    maxWidth: '100%',
    [`@media (max-width: ${breakpoints.tablet - 1}px)`]: {
      width: '100%',
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
  },
} as const;
